/**
 * PortfolioBreakdown Component JavaScript
 * Handles scroll animation for bars and "Show More" functionality
 */
(function() {
    'use strict';

    // Intersection Observer for bar chart animation
    function initScrollAnimation() {
        const holdingsChart = document.querySelector('.portfolio-holdings-chart');
        if (!holdingsChart) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1 }
        );

        observer.observe(holdingsChart);
    }

    // Show More button functionality for mobile
    function initShowMore() {
        const showMoreBtn = document.querySelector('.portfolio-holdings-show-more');
        if (!showMoreBtn) return;

        const totalCount = parseInt(showMoreBtn.getAttribute('data-total-count') || '0', 10);
        let visibleCount = parseInt(showMoreBtn.getAttribute('data-visible-count') || '10', 10);
        const incrementBy = 10;
        const textSpan = showMoreBtn.querySelector('.portfolio-holdings-show-more-text');
        const labelTemplate = showMoreBtn.getAttribute('data-label-show-more') || 'Show {0} more';

        // Set initial button text
        const initialRemaining = totalCount - visibleCount;
        if (initialRemaining <= 0) {
            showMoreBtn.style.display = 'none';
        } else if (textSpan) {
            textSpan.textContent = labelTemplate.replace('{0}', Math.min(incrementBy, initialRemaining));
        }

        showMoreBtn.addEventListener('click', function() {
            const newVisibleCount = Math.min(visibleCount + incrementBy, totalCount);

            // Show hidden items with animation
            for (let i = visibleCount; i < newVisibleCount; i++) {
                const row = document.querySelector('[data-holding-index="' + i + '"]');
                if (row) {
                    row.classList.remove('portfolio-holding-row--hidden');
                    // Trigger animation for newly visible bars
                    const bar = row.querySelector('.portfolio-holding-bar');
                    if (bar) {
                        // Reset and re-trigger animation
                        bar.style.width = '0';
                        setTimeout(function() {
                            bar.style.width = '';
                        }, 10);
                    }
                }
            }

            visibleCount = newVisibleCount;
            showMoreBtn.setAttribute('data-visible-count', visibleCount.toString());

            // Update button text or hide if all shown
            const remaining = totalCount - visibleCount;
            if (remaining <= 0) {
                showMoreBtn.style.display = 'none';
            } else if (textSpan) {
                textSpan.textContent = labelTemplate.replace('{0}', Math.min(incrementBy, remaining));
            }
        });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initScrollAnimation();
            initShowMore();
        });
    } else {
        initScrollAnimation();
        initShowMore();
    }
})();
